import type { ActionDescription } from "../../common/description";
import { ActionKind } from "../../common/description";
import type { AppDescriptionContext } from "../components";
import type { AppDescriptionVisitor, Location } from "../components/walk-app-description";
import { walkAppDescription } from "../components/walk-app-description";
import type { CompoundActionDescription } from "./compound-handler";
import { getCompoundActionProperty } from "../components/property-utils";
import { logError } from "../../common/debug-print";

export function forEachActionInApp(
    adc: AppDescriptionContext,
    processAction: (action: ActionDescription, location: Location) => void
): void {
    class Visitor implements AppDescriptionVisitor {
        public visitAction(location: Location, action: ActionDescription): void {
            processAction(action, location);
        }
    }

    walkAppDescription(adc, new Visitor(), true, true, false);
}

export function forEachBuilderActionInApp(
    adc: AppDescriptionContext,
    processAction: (action: CompoundActionDescription, actionID: string) => void
): void {
    forEachActionInApp(adc, action => {
        if (action.kind !== ActionKind.Compound) return;
        const compound = action as CompoundActionDescription;
        const actionID = getCompoundActionProperty(compound.actionID);
        if (actionID === undefined) {
            logError("No action ID for compound action");
            return;
        }
        processAction(compound, actionID);
    });
}
